export default "__VITE_ASSET__BgEyjqy1__"